import { Controller } from "@hotwired/stimulus"

// Toggles the per-school :class_photo_export Flipper flag from a checkbox on the
// school edit form. Mirrors auto_save_proof_type_controller: PATCHes on change so
// the admin doesn't have to submit the whole form, and the flag lives in Flipper
// rather than a school column.
export default class extends Controller {
  static values = { url: String }

  change(event) {
    const checkbox = event.target
    checkbox.disabled = true

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ enabled: checkbox.checked })
    })
      .then((response) => response.json())
      .then((data) => {
        checkbox.disabled = false
        if (data.success) {
          checkbox.checked = data.enabled
        } else {
          checkbox.checked = !checkbox.checked
          alert("Failed to update class-photo export")
        }
      })
      .catch((error) => {
        checkbox.disabled = false
        checkbox.checked = !checkbox.checked
        console.error("Error:", error)
        alert("Failed to update class-photo export")
      })
  }
}
